import {
  type FieldError,
  type FieldValues,
  type Path,
  type UseFormRegister,
} from 'react-hook-form'

import { type FieldOption, FormSelectField, FormSelectFieldDS, type FormSelectFieldDSProps } from './FormFields'

type StateDropdownType = {
  state: string;
} & FieldValues

export const USStates = [
  { label: 'Select a state', value: '' },
  { label: 'Alabama', value: 'AL' },
  { label: 'Alaska', value: 'AK' },
  { label: 'Arizona', value: 'AZ' },
  { label: 'Arkansas', value: 'AR' },
  { label: 'California', value: 'CA' },
  { label: 'Colorado', value: 'CO' },
  { label: 'Connecticut', value: 'CT' },
  { label: 'Delaware', value: 'DE' },
  { label: 'District Of Columbia', value: 'DC' },
  { label: 'Florida', value: 'FL' },
  { label: 'Georgia', value: 'GA' },
  { label: 'Hawaii', value: 'HI' },
  { label: 'Idaho', value: 'ID' },
  { label: 'Illinois', value: 'IL' },
  { label: 'Indiana', value: 'IN' },
  { label: 'Iowa', value: 'IA' },
  { label: 'Kansas', value: 'KS' },
  { label: 'Kentucky', value: 'KY' },
  { label: 'Louisiana', value: 'LA' },
  { label: 'Maine', value: 'ME' },
  { label: 'Maryland', value: 'MD' },
  { label: 'Massachusetts', value: 'MA' },
  { label: 'Michigan', value: 'MI' },
  { label: 'Minnesota', value: 'MN' },
  { label: 'Mississippi', value: 'MS' },
  { label: 'Missouri', value: 'MO' },
  { label: 'Montana', value: 'MT' },
  { label: 'Nebraska', value: 'NE' },
  { label: 'Nevada', value: 'NV' },
  { label: 'New Hampshire', value: 'NH' },
  { label: 'New Jersey', value: 'NJ' },
  { label: 'New Mexico', value: 'NM' },
  { label: 'New York', value: 'NY' },
  { label: 'North Carolina', value: 'NC' },
  { label: 'North Dakota', value: 'ND' },
  { label: 'Ohio', value: 'OH' },
  { label: 'Oklahoma', value: 'OK' },
  { label: 'Oregon', value: 'OR' },
  { label: 'Pennsylvania', value: 'PA' },
  { label: 'Rhode Island', value: 'RI' },
  { label: 'South Carolina', value: 'SC' },
  { label: 'South Dakota', value: 'SD' },
  { label: 'Tennessee', value: 'TN' },
  { label: 'Texas', value: 'TX' },
  { label: 'Utah', value: 'UT' },
  { label: 'Vermont', value: 'VT' },
  { label: 'Virginia', value: 'VA' },
  { label: 'Washington', value: 'WA' },
  { label: 'West Virginia', value: 'WV' },
  { label: 'Wisconsin', value: 'WI' },
  { label: 'Wyoming', value: 'WY' },
]

export function getAbbreviation (fullName: string): string {
  const state = USStates.find(
    (state) => state.label.toLowerCase() === fullName.toLowerCase()
  )
  return state ? state.value : ''
}

export function getFullName (abbreviation: string): string {
  const state = USStates.find(
    (state) => state.value === abbreviation
  )
  return state ? state.label : ''
}

export function StateDropdown<T extends StateDropdownType> ({
  disabled,
  register,
  required,
  error,
}: {
  disabled?: boolean;
  register: UseFormRegister<T>;
  required?: boolean;
  error?: FieldError;
}) {
  const stateValidation = required
    ? { required: 'State is required.' }
    : undefined
  return (
    <FormSelectField<T>
      disabled={disabled}
      error={error}
      fieldId={'state' as Path<T>}
      fieldLabel='State'
      fieldOptions={USStates}
      register={register}
      validationRule={stateValidation}
    />
  )
}

export function SlabStateDropdown<T extends FieldValues> ({
  disabled,
  error,
  fieldId,
  fieldLabel,
  fieldOptions = USStates,
  placeholder,
  register,
  validationRule,
}: Omit<FormSelectFieldDSProps<T>, 'fieldOptions'> & {
  fieldOptions?: FieldOption[];
}) {
  return (
    <FormSelectFieldDS<T>
      disabled={disabled}
      error={error}
      fieldId={fieldId}
      fieldLabel={fieldLabel}
      fieldOptions={fieldOptions}
      placeholder={placeholder}
      register={register}
      validationRule={validationRule}
    />
  )
}
